import axios from 'axios'
import baseURL from '../api/api'

export const api = axios.create({
    baseURL: baseURL,
    headers: { 'Content-Type': 'application/json' },
})

export const axiosPrivate = axios.create({
    baseURL: baseURL,
    headers: { 'Content-Type': 'application/json' },
    withCredentials: true,
})
